import React from 'react'
import { Stack, Skeleton, Group, Paper } from '@mantine/core'

interface PriceDropsTableSkeletonProps {
    count?: number
}

export const PriceDropsTableSkeleton: React.FC<PriceDropsTableSkeletonProps> = ({
    count = 5
}) => {
    return (
        <div style={{ width: '100%' }}>
            <Stack gap="md" w="100%">
                <Stack gap={0}>
                    {Array.from({ length: count }).map((_, index) => (
                        <Paper
                            key={index}
                            p="xs"
                            radius="xl"
                            style={{
                                cursor: 'default'
                            }}
                        >
                            <Group justify="space-between" align="center">
                                <Group gap="sm" style={{ flex: 1, minWidth: 0 }}>
                                    <Skeleton
                                        width={50}
                                        height={50}
                                        radius="sm"
                                    />
                                    <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>
                                        <Skeleton height={14} width="80%" radius="sm" />
                                        <Skeleton height={18} width={60} radius="sm" />
                                    </Stack>
                                </Group>
                                <Stack gap={4} align="flex-end" style={{ flexShrink: 0 }}>
                                    <Group gap={6}>
                                        <Skeleton height={12} width={40} radius="sm" />
                                        <Skeleton height={16} width={50} radius="sm" />
                                    </Group>
                                    <Skeleton height={18} width={60} radius="sm" />
                                </Stack>
                            </Group>
                        </Paper>
                    ))}
                </Stack>
            </Stack>
        </div>
    )
} 